import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const MessageIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 21 20"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 20)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18.54 1H2.46c-.39 0-.76.15-1.03.4-.28.27-.43.62-.43.98v11.77c0 .37.15.72.43.98.27.26.64.4 1.03.4h2.92V19l4.56-3.46h8.6c.39 0 .76-.15 1.03-.4.28-.27.43-.62.43-.99V2.38c0-.36-.15-.71-.43-.97A1.5 1.5 0 0 0 18.54 1Z" />
      <path d="M5.28 6.02h10.44M5.28 9.25h7.03" />
    </SVG>
  );
};
